<script>
  import AddList from "../form/AddList.svelte";
  import SingleCheckbox from "../form/SingleCheckbox.svelte";
  import Validators from "../../utils/validators";

  // fields
  let typeField = [
    {
      type: "text",
      name: "type",
      label: "Type",
      readonlyValue: true,
      validations: [Validators.required("Type is required")],
    },
  ];

  let passingField = [
    {
      type: "text",
      name: "passing",
      label: "Passing",
      readonlyValue: true,
      validations: [Validators.required("Passing is required")],
    },
  ];

  let typeData = [];
  let passingData = [];

  let isRevenue = true;
  let isMargin = false;
  let isFillRate = false;

  function onAddType(data) {
    const newType = { ...data };
    typeData.push(newType);
    return typeData;
  }

  function onDeleteType(index) {
    typeData.splice(index, 1);
    return typeData;
  }

  function onAddPassing(data) {
    const newPassing = { ...data };
    passingData.push(newPassing);
    return passingData;
  }

  function onDeletePassing(index) {
    passingData.splice(index, 1);
    return passingData;
  }
</script>

<div class="flex flex-row w-full gap-2 pb-2">
  <AddList
    name="type"
    fields={typeField}
    data={typeData}
    onAddRow={onAddType}
    onDeleteRow={onDeleteType}
  />
  <AddList
    name="passing"
    fields={passingField}
    data={passingData}
    onAddRow={onAddPassing}
    onDeleteRow={onDeletePassing}
  />
</div>

<h1 class="py-2 text-xl">Priority</h1>
<div class="flex gap-4">
  <SingleCheckbox name="revenue" label="Revenue" bind:value={isRevenue} />
  <SingleCheckbox name="margin" label="Margin" bind:value={isMargin} />
  <SingleCheckbox name="fill_rate" label="Fill Rate" bind:value={isFillRate} />
</div>
